import LabChart from './LabChart';

export default LabChart;
